import { render, staticRenderFns } from "./ModalBuscarAgendamento.vue?vue&type=template&id=1fb22bb6&scoped=true"
import script from "./ModalBuscarAgendamento.vue?vue&type=script&lang=ts"
export * from "./ModalBuscarAgendamento.vue?vue&type=script&lang=ts"
import style0 from "./ModalBuscarAgendamento.vue?vue&type=style&index=0&id=1fb22bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb22bb6",
  null
  
)

export default component.exports